module.exports = __webpack_public_path__ + "img/LanghamChicagoMobile.0ba3e5aa.jpg";